import { observer } from 'mobx-react';
import React from 'react';
import { Tracker } from '@udemy/event-tracking';
import { useI18n } from '@udemy/i18n';
import { UFB_ROUTES } from '@udemy/organization';
import { HeaderButton } from '../../desktop/header-dropdown.react-component';
import { useHeaderStore } from '../../hooks/use-header-store';
import { ManageOrganizationSelected } from './events';
export const ManageButton = observer(() => {
  const headerStore = useHeaderStore();
  const {
    gettext
  } = useI18n();
  const {
    organizationState
  } = headerStore.userSpecificContext;
  if (!(organizationState !== null && organizationState !== void 0 && organizationState.should_show_manage_menu)) {
    return null;
  }
  const sendSelectedEvent = () => Tracker.publishEvent(new ManageOrganizationSelected());
  return /*#__PURE__*/React.createElement(HeaderButton, {
    "data-testid": "manage-simple-button",
    "data-intercom-target": "header.manage-ufb",
    componentClass: "a",
    href: UFB_ROUTES.orgAdminOverview,
    onClick: sendSelectedEvent
  }, gettext('Manage'));
});
//# sourceMappingURL=manage-button.react-component.js.map